import { memo } from 'react';
import { Spin } from 'antd';
import { useStore } from '@/store';
import styles from './index.module.scss';

interface GlobalLoadingProps {
  visible: boolean;
  // 各关键接口的加载状态，用于精确展示「当前在加载哪个数据」
  pending: {
    poetry: boolean;
    landmark: boolean;
    events: boolean;
    place: boolean;
  };
}

const POETRY_STAGE_TEXT: Record<string, string> = {
  list: '正在获取地标列表…',
  neighbour: '正在加载诗词地标数据',
  retry: '正在补全数据…',
};

const GlobalLoading = ({ visible, pending }: GlobalLoadingProps) => {
  const progress = useStore((s) => s.poetryProgress);
  if (!visible) return null;

  // 诗词地标还在加载：展示分段进度（最慢，且有逐地标进度）
  if (pending.poetry) {
    const p = progress;
    const stage = p?.stage ?? 'list';
    const text = POETRY_STAGE_TEXT[stage] || '正在加载诗词地标数据';
    const showBar = stage === 'neighbour' && !!p && p.total > 0;
    const percent = showBar && p ? Math.round((p.current / p.total) * 100) : 0;
    return (
      <div className={styles.mask}>
        <Spin size="large" />
        <p className={styles.text}>{text}</p>
        {showBar && (
          <>
            <div className={styles.barTrack}>
              <div className={styles.barFill} style={{ width: `${percent}%` }} />
            </div>
            <p className={styles.count}>
              {p?.current} / {p?.total} 个地标（{percent}%）
            </p>
          </>
        )}
        {stage === 'retry' && (
          <p className={styles.count}>超大地标数据较多，正在补全，请稍候…</p>
        )}
      </div>
    );
  }

  // 诗词已完成，但仍有其它接口在加载——展示当前在加载哪个，避免误报「加载完成」
  const label = pending.landmark
    ? '首页地标数据'
    : pending.events
      ? '大事件数据'
      : pending.place
        ? '坐标数据'
        : '数据';
  return (
    <div className={styles.mask}>
      <Spin size="large" />
      <p className={styles.text}>正在加载{label}…</p>
    </div>
  );
};

export default memo(GlobalLoading);
